import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ec09789"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-account px-10 mb-20" }
const _hoisted_2 = { class: "create-account__wrapper text-center pa-40" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-10" }, "Регистрация", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-gradient text-center mb-20 d-inline-flex" }, "Авторизация", -1))
const _hoisted_5 = { class: "errors mb-10" }
const _hoisted_6 = {
  key: 0,
  class: "error color-red"
}
const _hoisted_7 = {
  key: 1,
  class: "error color-red"
}
const _hoisted_8 = {
  key: 2,
  class: "error color-red"
}
const _hoisted_9 = { class: "text-gradient d-inline-flex flex-direction-column" }
const _hoisted_10 = { class: "text-center mb-10" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<h6 class=\"text-center mb-10\" data-v-6ec09789><span data-v-6ec09789>Продолжая, вы принимаете</span> <a href=\"/media/original/user/vabods/ffe1368d9d334be19cc575828415c5c4.%D0%A3%D1%81%D0%BB%D0%BE%D0%B2%D0%B8%D1%8F_%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.pdf\" data-v-6ec09789>условия использования</a><span data-v-6ec09789>,<br data-v-6ec09789>а также подтверждаете, что ознакомились<br data-v-6ec09789>с документом</span> <a href=\"/media/original/user/vabods/3947fcdb9f9444cd9b9ffa708b26644b.%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0_%D0%BA%D0%BE%D0%BD%D1%84%D0%B5%D0%B4%D0%B5%D0%BD%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8.pdf\" data-v-6ec09789>«Политика конфиденциальности»</a>.</h6><br data-v-6ec09789><h5 data-v-6ec09789><span data-v-6ec09789>Уже есть аккаунт?</span></h5>", 3)

import CircleButton from '@/components/Buttons/CircleButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import BackLine from '@/components/Lines/BackLine.vue'
import { computed, ref } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useRoute, useRouter } from 'vue-router'
import { IValidateForm, Validate } from '@/helpers/validate'
import SocLinks from '@/components/SocLinks.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {


const authStore = useAuthStore()
const router = useRouter()
const route = useRoute()
const errors = ref<any>({})
const isLoading = ref<boolean>(false)
const username = ref<string>('')
const email = ref<string>('')
const password = ref<string>('')
const isAuth = computed(() => authStore.isAuth)
const currentField = ref<string>('')

const inFocus = (input: string) => {
  currentField.value = input
  delete errors.value[input]
}
const outFocus = (
  input: string,
  // ESLINT-ERROR: Старая реализация
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any,
  title: string,
  rules: string[]
) => {
  currentField.value = ''
  errors.value = Validate([
    {
      name: input,
      rules: rules as IValidateForm['rules'],
      value: model,
      ru: title
    }
  ])
}
const setLoading = (status: boolean) => {
  isLoading.value = status
}
const onSubmit = async () => {
  const validate = Validate([
    {
      name: 'username',
      rules: ['required', 'notemail', 'lower'],
      value: username.value,
      ru: 'ник'
    },
    {
      name: 'email',
      rules: ['required', 'email_split'],
      value: email.value,
      ru: 'e-mail'
    },
    {
      name: 'password',
      rules: ['required'],
      value: password.value,
      ru: 'пароль'
    }
  ])
  errors.value = {}
  if (Object.keys(validate).length) {
    errors.value = validate
  } else {
    setLoading(true)
    const result = await authStore
      .register({
        email: email.value,
        username: username.value,
        name: username.value,
        password1: password.value
      }).finally(() => setLoading(false))

    if (result.result?.message && result?.result?.message.toString().includes('success')) {
      authStore.setAuth({ result: { token: 'registertoken', username: username.value } })
      if (isAuth.value) {
        await router.push(route.redirectedFrom?.path || '/login/success')
      }
    } else {
      if (result?.errors.length) {
        errors.value.detail = result.errors
      }
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackLine, null, {
      default: _withCtx(() => [
        _createVNode(CircleButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
          name: "chevron-left-gradient",
          bg: "empty",
          iconWidth: 21,
          iconHeight: 16,
          "view-box": "0 0 21 16"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("form", {
          class: "create-account__form",
          onSubmit: _withModifiers(onSubmit, ["prevent"]),
          enctype: "multipart/form-data"
        }, [
          _createVNode(BaseInput, {
            onFocusin: _cache[1] || (_cache[1] = ($event: any) => (inFocus('username'))),
            onFocusout: _cache[2] || (_cache[2] = ($event: any) => (
          outFocus('username', username.value, 'ник', ['required', 'notemail', 'lower'])
        )),
            modelValue: username.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((username).value = $event)),
            type: "text",
            class: "mb-10 full-width",
            placeholder: "Ник"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            onFocusin: _cache[4] || (_cache[4] = ($event: any) => (inFocus('email'))),
            onFocusout: _cache[5] || (_cache[5] = ($event: any) => (
          outFocus('email', email.value, 'e-mail', ['required', 'email_split'])
        )),
            modelValue: email.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((email).value = $event)),
            type: "text",
            class: "mb-10 full-width",
            placeholder: "Почта"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            onFocusin: _cache[7] || (_cache[7] = ($event: any) => (inFocus('password'))),
            onFocusout: _cache[8] || (_cache[8] = ($event: any) => (
          outFocus('password', password.value, 'пароль', ['required'])
        )),
            modelValue: password.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((password).value = $event)),
            type: "password",
            class: "mb-10 full-width",
            placeholder: "Пароль"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseButton, {
            disabled: isLoading.value || !!Object.keys(errors.value).length,
            class: "large rounded margin-auto mb-20 full-width",
            bg: "gradient",
            border: "gradient"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Зарегистрироваться")
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 32),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value?.detail, (errorDetail, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "error color-red"
            }, _toDisplayString(errorDetail), 1))
          }), 128)),
          (errors.value.email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errors.value?.email[0]), 1))
            : _createCommentVNode("", true),
          (errors.value.username)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errors.value?.username[0]), 1))
            : _createCommentVNode("", true),
          (errors.value.password)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(errors.value?.password[0]), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h5", _hoisted_10, [
            _createVNode(_component_router_link, { to: {name: 'login-restore'} }, {
              default: _withCtx(() => [
                _createTextVNode("Забыли пароль? Восстановить")
              ]),
              _: 1
            })
          ]),
          _hoisted_11,
          _createElementVNode("h5", null, [
            _createVNode(_component_router_link, { to: {name: 'login'} }, {
              default: _withCtx(() => [
                _createTextVNode("Войти")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(SocLinks)
    ])
  ], 64))
}
}

})